module.exports = __webpack_public_path__ + "static/media/brego3596.6c62c50b.jpg";